import { StyleSheet } from '@react-pdf/renderer';

export const pxToPt = (px: number): number => +(px * 0.75).toFixed(2); // округляем до двух знаков после запятой

export const styles = StyleSheet.create({
  page: {
    fontFamily: 'Roboto',
    fontSize: 14,
    padding: 40,
    backgroundColor: '#ffffff',
    color: '#535353',
  },
  section: {
    marginBottom: 20,
  },
  heading: {
    fontSize: 24,
    fontWeight: 600,
    marginBottom: 6,
  },
  subheading: {
    fontSize: 16,
    color: '#535353',
  },
  bold: {
    fontWeight: 'bold',
  },
  contactList: {
    marginTop: 8,
  },
  contactItem: {
    flexDirection: 'row',
    gap: 4,
  },
  skills: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 4,
  },
  text: {
    marginBottom: 4,
    fontSize: 12,
  },
  image: {
    width: 64,
    height: 64,
    borderRadius: '50%',
  },
  spaceBottom: {
    marginBottom: 8,
  },
  spaceBottomBig: {
    marginBottom: 12,
  },
  iconSolid: {
    fontFamily: 'FontAwesome',
    fontWeight: 900,
    fontSize: 12,
    marginRight: 8,
    color: '#AFAFAF',
  },
  iconRegular: {
    fontFamily: 'FontAwesome',
    fontWeight: 400,
    fontSize: 12,
    marginRight: 8,
    color: '#AFAFAF',
  },
  iconBrands: {
    fontFamily: 'FontAwesomeBrands',
    fontWeight: 400,
    fontSize: 12,
    marginRight: 8,
    color: '#AFAFAF',
  },
});
